:root,
.uic-theme-responsive {
  --uxc-app-header-height: 52px;
  --uxc-app-header-expandables-y-offset: 56px;
  --uxc-app-header-expandables-min-width: 300px;
  --uxc-app-header-z-index: 400;
  --uxc-app-header-bg-color: var(--uic-color-blue5);
  --uxc-app-header-separator-color: var(--uic-color-white);
  --uxc-app-header-launcher-width: 68px;
}

@media only screen and (min-width: 1024px) {
  .uic-theme-responsive {
    --uxc-app-header-height: 68px;
    --uxc-app-header-expandables-y-offset: 72px;
    --uxc-app-header-launcher-width: 85px;
  }
}
:root,
.uic-theme-responsive {
  --uxc-app-toast-notifications-z-index: 350;
}

/**
* @prop --app-info-image-width-mobile: width of the app info image on mobile
* @prop --app-info-image-height-mobile: height of the app info image on mobile
* @prop --app-info-image: image shown in the app info tile
* @prop --app-info-image-background-size: background size of the app info image (contain|cover)
* @prop --app-info-image-background-repeat: background repeat of the app info image (no-repeat|repeat)
 */
:host {
  display: block;
  min-height: 220px;
  font-family: var(--ux-font);
}

.grid {
  display: grid;
  grid-template-areas: "tile";
  min-height: 220px;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  padding: 16px;
  gap: 10px;
}

.left {
  max-width: 40%;
}
@media (min-width: 460px) {
  .left {
    max-width: 33%;
  }
}

.right {
  display: flex;
  align-content: flex-start;
  flex-direction: column;
  flex-grow: 1;
}
@media (min-width: 460px) {
  .right {
    flex-direction: row;
    flex-wrap: wrap;
  }
}

uic-output {
  width: 100%;
}
@media (min-width: 460px) {
  uic-output {
    width: 48%;
  }
}

.tile {
  width: 100%;
  height: 100%;
  grid-area: tile;
}

.image {
  width: var(--app-info-image-width-mobile, 100px);
  height: var(--app-info-image-height-mobile, 100px);
  background-size: var(--app-info-image-background-size, contain);
  background-repeat: var(--app-info-image-background-repeat, no-repeat);
  background-image: var(--app-info-image, url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiBmaWxsPSJub25lIj48ZyBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGZpbGw9InVybCgjYikiIGQ9Ik0xMjggMEgwdjEyOGgxMjhWMFoiLz48cGF0aCBmaWxsPSJ1cmwoI2MpIiBmaWxsLW9wYWNpdHk9Ii42MiIgZD0iTTY0IDEyOS4wNjdjMzUuMzQ2IDAgNjQtNy44OCA2NC0xNy42IDAtOS43MjEtMjguNjU0LTE3LjYtNjQtMTcuNi0zNS4zNDYgMC02NCA3Ljg3OS02NCAxNy42IDAgOS43MiAyOC42NTQgMTcuNiA2NCAxNy42WiIvPjwvZz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNDYuMzM4IDQyLjUxMmg2LjU3djYuNTdoLTYuNTd2LTYuNTdaTTM1LjgyNiA0Mi41MTJoNi41N3Y2LjU3aC02LjU3di02LjU3Wk01Ni44NSA0Mi41MTJoNi41N3Y2LjU3aC02LjU3di02LjU3Wk00Ni4zMzggNTQuMzM4aDYuNTd2Ni41N2gtNi41N3YtNi41N1pNMzUuODI2IDU0LjMzOGg2LjU3djYuNTdoLTYuNTd2LTYuNTdaTTQ2LjMzOCA2NC44NWg2LjU3djYuNTdoLTYuNTd2LTYuNTdaTTU2Ljg1IDY0Ljg1aDYuNTd2Ni41N2gtNi41N3YtNi41N1pNMzUuODI2IDY0Ljg1aDYuNTd2Ni41N2gtNi41N3YtNi41N1pNNTYuODUgNTQuMzM4aDYuNTd2Ni41N2gtNi41N3YtNi41N1pNNjcuMzYyIDQyLjUxMmg2LjU3djYuNTdoLTYuNTd2LTYuNTdaTTY3LjM2MiA1NC4zMzhoNi41N3Y2LjU3aC02LjU3di02LjU3WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0yNCAzMnY0OS41MDJoMzUuMzA5djguMTM5SDUyLjE0djQuMTE3aDIyLjU3NnYtNC4xMTdoLTcuMTg0VjgxLjVoOS44ODdhMTkuMjIzIDE5LjIyMyAwIDAgMS0xLjAxOC00Ljg4OUgyOC45NDRWMzYuODloNjguOTY4djE5LjMxM2MxLjY5OC4yMzUgMy4zNTYuNyA0LjkyOSAxLjM4NFYzMkgyNFoiLz48cGF0aCBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0xMDYuOTkgODMuODI1IDcuNjc3IDcuNy0zLjcyNyAzLjU0Ny03Ljc0LTcuNzY3Yy02LjM3OCA0LjA1My0xNC44NjcgMi42NzYtMTkuNTYzLTMuMTczLTQuNjk3LTUuODUtNC4wNDgtMTQuMjM2IDEuNDk2LTE5LjMyOCA1LjU0My01LjA5MyAxNC4xNDctNS4yMDYgMTkuODI5LS4yNjEgNS42ODIgNC45NDQgNi41NjIgMTMuMzEgMi4wMjggMTkuMjgyWm0tMjAuNTM3LTQuOTg5YzEuNDY3IDMuNDU3IDQuOTIgNS43MSA4Ljc0OSA1LjcwOCA1LjIyMy0uMDA4IDkuNDU0LTQuMTQ2IDkuNDYtOS4yNTIgMC0zLjc0Mi0yLjMwNy03LjExNi01Ljg0NC04LjU0Ny0zLjUzOC0xLjQzMi03LjYxLS42NC0xMC4zMTYgMi4wMDctMi43MDcgMi42NDctMy41MTUgNi42MjctMi4wNDkgMTAuMDg0WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PGRlZnM+PHJhZGlhbEdyYWRpZW50IGlkPSJiIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMTY4Ljk2IDAgMCAxNzAuMzY4IDYyLjA4IDE3MS44NTIpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agc3RvcC1jb2xvcj0iIzE3N0FDOSIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE0MjkzOSIvPjwvcmFkaWFsR3JhZGllbnQ+PHJhZGlhbEdyYWRpZW50IGlkPSJjIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMCAxNC40MzIgLTY2LjMwODUgMCA2NC42MzcgMTEwLjY5OSkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjNTFBN0VCIiBzdG9wLW9wYWNpdHk9Ii44Ii8+PHN0b3Agb2Zmc2V0PSIuNTQiIHN0b3AtY29sb3I9IiM1MUE3RUIiIHN0b3Atb3BhY2l0eT0iLjI1Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNTFBN0VCIiBzdG9wLW9wYWNpdHk9IjAiLz48L3JhZGlhbEdyYWRpZW50PjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGgxMjh2MTI4SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+Cg=="));
}
@media (min-width: 460px) {
  .image {
    width: var(--app-info-image-width, 128px);
    height: var(--app-info-image-height, 128px);
    background-size: var(--app-info-image-background-size, contain);
    background-repeat: var(--app-info-image-background-repeat, no-repeat);
  }
}

.links {
  list-style: none;
  padding: 0;
  margin-top: 35px;
}

.link {
  color: #285172;
  font-size: 14px;
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}